module.exports = __webpack_public_path__ + "img/jiushui.4afae902.png";